import { DropdownItemModel } from "@interfaces/models";
import { Dropdown } from "@components/index";

export const SubmissionsStatusFilter = ({
  height = "medium",
  width,
  value = "",
  onSetStatus,
  dataTestid,
}: {
  height?: "small" | "medium";
  width?: string;
  defaultIsEmpty?: boolean;
  variant?: "filter" | "formField";
  value?: string;
  onSetStatus?: (statusId: string) => void;
  dataTestid?: string;
}) => {
  const statuses: DropdownItemModel[] = [
    {
      id: "open",
      title: "Open",
    },
    {
      id: "waiting_for_review",
      title: "Waiting for review",
    },
    {
      id: "in_review",
      title: "In review",
    },
    {
      id: "reopened",
      title: "Re-opened",
    },
    {
      id: "complete",
      title: "Complete",
    },
    {
      id: "sent_to_hmrc",
      title: "Sent to HMRC",
    },
  ];

  const handleSelectStatus = (id: string) => {
    if (onSetStatus) {
      onSetStatus(id);
    }
  };

  return (
    <Dropdown
      items={statuses}
      height={height}
      width={width}
      placeholder="Status"
      showClearButton
      value={value}
      onSelect={handleSelectStatus}
      dataTestid={dataTestid}
    />
  );
};
